function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React, { Children } from "react";
import PropTypes from "prop-types";
import Accordion from "./Accordion";
import Container from "./Container";
import Flex from "./Flex";
import Icon from "./Icon";
import Link from "./Link";
import Stack from "./Stack";
import Text from "./Text";
import useBreakpoint from "../hooks/useBreakpoint";
import useTheme from "../hooks/useTheme";
import Logo from "./internal/Logo";
import useFooterLinks, { FooterLinksProvider } from "../hooks/useFooterLinks";
import { compareBreakpoints } from "../utils/css";
import { mergeProps } from "../utils/component";
import { jsx as ___EmotionJSX } from "@emotion/core";

function HeaderLogo(_ref) {
  var name = _ref.name,
      testId = _ref.testId;
  return ___EmotionJSX(Container, {
    height: "56",
    "height-lg": "80",
    testId: testId
  }, ___EmotionJSX(Flex, {
    height: "100%",
    placeItems: "left center"
  }, ___EmotionJSX(Logo, {
    name: name,
    color: "white",
    height: "36",
    "height-xs": "40",
    "height-lg": "48",
    maxWidth: "120",
    "maxWidth-xs": "none"
  })));
}

HeaderLogo.propTypes = {
  name: PropTypes.oneOf(Logo.NAMES).isRequired,
  testId: PropTypes.string
};

function HeaderSocial(_ref2) {
  var children = _ref2.children,
      testId = _ref2.testId;
  return ___EmotionJSX(Container, {
    height: "56",
    width: "100%",
    "width-sm": "auto",
    "margin-sm": "0 0 0 auto",
    testId: testId
  }, ___EmotionJSX(Flex, {
    height: "100%",
    placeItems: "left center"
  }, ___EmotionJSX(Text, {
    margin: "0",
    "margin-sm": "0 4 0 0"
  }, ___EmotionJSX("strong", null, "Connect with us")), ___EmotionJSX(Stack, {
    direction: "horizontal",
    gap: "3",
    margin: "0 0 0 auto",
    "margin-sm": "0"
  }, children)));
}

HeaderSocial.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function SocialFacebook(_ref3) {
  var href = _ref3.href,
      title = _ref3.title,
      testId = _ref3.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "facebook",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialFacebook.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  testId: PropTypes.string
};

function SocialYouTube(_ref4) {
  var href = _ref4.href,
      title = _ref4.title,
      testId = _ref4.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "youtube",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialYouTube.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  testId: PropTypes.string
};

function SocialTwitter(_ref5) {
  var href = _ref5.href,
      title = _ref5.title,
      testId = _ref5.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "twitter",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialTwitter.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  testId: PropTypes.string
};

function SocialInstagram(_ref6) {
  var href = _ref6.href,
      title = _ref6.title,
      testId = _ref6.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "instagram",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialInstagram.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  testId: PropTypes.string
};

function SocialLinkedIn(_ref7) {
  var href = _ref7.href,
      title = _ref7.title,
      testId = _ref7.testId;
  return ___EmotionJSX(Link, {
    appearance: "icon",
    href: href,
    newTab: true,
    title: title,
    testId: testId
  }, ___EmotionJSX(Icon, {
    name: "linkedin",
    color: "white",
    hoverColor: "secondary.lightBlue.t60"
  }));
}

SocialLinkedIn.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  testId: PropTypes.string
};

function Header(_ref8) {
  var children = _ref8.children,
      testId = _ref8.testId;
  return ___EmotionJSX(Container, {
    bg: "primary.blue.t100",
    testId: testId
  }, ___EmotionJSX(Container, {
    bg: "primary.blue.t100",
    hasBreakpointWidth: true
  }, ___EmotionJSX(Flex, {
    direction: "column",
    "direction-sm": "row",
    placeItems: "left center"
  }, children)));
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
var SECTION_TITLES_AS = ["h2", "h3", "h4", "h5", "h6"];
var LINKS_DEFAULT_PROPS = {
  sectionTitlesAs: "h5",
  switchLayoutAt: "md"
};
Links.SECTION_TITLES_AS = SECTION_TITLES_AS;
Links.DEFAULT_PROPS = LINKS_DEFAULT_PROPS;

var _ref9 = process.env.NODE_ENV === "production" ? {
  name: "gg4vpm",
  styles: "display:flex;justify-content:space-between;"
} : {
  name: "gg4vpm",
  styles: "display:flex;justify-content:space-between;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Links(props) {
  var mergedProps = mergeProps(props, LINKS_DEFAULT_PROPS);
  var sectionTitlesAs = mergedProps.sectionTitlesAs,
      switchLayoutAt = mergedProps.switchLayoutAt,
      children = mergedProps.children,
      testId = mergedProps.testId;
  var theme = useTheme();
  var bp = useBreakpoint();
  var result = compareBreakpoints(bp, switchLayoutAt, theme);
  var isColumnsLayout = result >= 0;
  return ___EmotionJSX(FooterLinksProvider, {
    value: {
      sectionTitlesAs: sectionTitlesAs
    }
  }, ___EmotionJSX(Container, {
    bg: isColumnsLayout ? "white" : "primary.blue.t100",
    padding: isColumnsLayout ? "8 0" : "8 0 0 0",
    testId: testId
  }, ___EmotionJSX(Container, {
    hasBreakpointWidth: true
  }, isColumnsLayout ? ___EmotionJSX("div", {
    css: _ref9
  }, children) : ___EmotionJSX(Accordion, {
    itemGap: "small"
  }, Children.map(children, function (child, index) {
    return ___EmotionJSX(Accordion.Item, {
      key: index
    }, ___EmotionJSX(Accordion.Item.Header, null, child.props.title), ___EmotionJSX(Accordion.Item.Content, null, ___EmotionJSX(Stack, {
      gap: "5"
    }, child.props.children)));
  })))));
}

Links.propTypes = {
  sectionTitlesAs: PropTypes.oneOf(SECTION_TITLES_AS),
  switchLayoutAt: PropTypes.string,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function LinksSection(_ref10) {
  var title = _ref10.title,
      children = _ref10.children,
      testId = _ref10.testId;

  var _useFooterLinks = useFooterLinks(),
      sectionTitlesAs = _useFooterLinks.sectionTitlesAs;

  return ___EmotionJSX("div", {
    "data-testid": testId
  }, ___EmotionJSX(Text, {
    as: sectionTitlesAs,
    textStyle: "subtitle2",
    margin: "0 0 4 0"
  }, ___EmotionJSX("strong", null, title)), ___EmotionJSX(Stack, {
    gap: "5"
  }, children));
}

LinksSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function LegalLinks(_ref11) {
  var children = _ref11.children,
      testId = _ref11.testId;
  var links = React.Children.toArray(children).filter( // Ignore all children that aren't a Link
  function (child) {
    return child.type === Link;
  });
  return ___EmotionJSX(Container, {
    padding: "0 4",
    "padding-lg": "0",
    textAlign: "center"
  }, ___EmotionJSX(Stack, {
    direction: "horizontal",
    align: "center",
    gap: "3 4",
    testId: testId
  }, links));
}

LegalLinks.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function LegalCopy(_ref12) {
  var children = _ref12.children,
      testId = _ref12.testId;
  return ___EmotionJSX(Container, {
    textStyle: "legal",
    margin: "7 0 0 0",
    testId: testId
  }, children);
}

LegalCopy.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function Legal(_ref13) {
  var children = _ref13.children,
      testId = _ref13.testId;
  return ___EmotionJSX(Container, {
    bg: "secondary.lightBlue.t25",
    testId: testId
  }, ___EmotionJSX(Container, {
    hasBreakpointWidth: true,
    padding: "9 0",
    textAlign: "center"
  }, children));
}

Legal.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

function Footer(_ref14) {
  var children = _ref14.children,
      testId = _ref14.testId;
  return ___EmotionJSX("footer", {
    "data-testid": testId
  }, children);
}

Footer.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
Footer.Header = Header;
Footer.Header.Logo = HeaderLogo;
Footer.Header.Social = HeaderSocial;
Footer.Header.Social.Facebook = SocialFacebook;
Footer.Header.Social.YouTube = SocialYouTube;
Footer.Header.Social.Twitter = SocialTwitter;
Footer.Header.Social.Instagram = SocialInstagram;
Footer.Header.Social.LinkedIn = SocialLinkedIn;
Footer.Links = Links;
Footer.Links.Section = LinksSection;
Footer.Legal = Legal;
Footer.Legal.Links = LegalLinks;
Footer.Legal.Copy = LegalCopy;
export default Footer;